import React from 'react';
import { string, instanceOf, func, number } from 'prop-types';

import IconFolderClose from '../../../shared/icons/IconFolderClose';

const DefinationFolderView = ({
  title,
  folders,
  setActiveStudyTarget,
  maxHeight,
}) => {
  const _renderFolderList = () => {
    return folders.map(item => {
      const isNew = item.new > 0;
      const activeClass = item.isActive
        ? 'de--def__folder-list--item de--def__folder-list--item-active'
        : 'de--def__folder-list--item';
      return (
        <div className={activeClass} key={item.id}>
          <button
            type="button"
            title={item.name}
            onClick={() => setActiveStudyTarget(item)}
            className="de--def__folder--button"
          >
            <span className="de--def__folder--button-icon">
              <IconFolderClose fill={item.isActive ? '#ffffff' : '#7994BB'} />
            </span>
            <span className="de--def__folder--button-text">{item.name}</span>
          </button>
          <div className="de--def__folder--new">{isNew ? 'New' : '  '}</div>
        </div>
      );
    });
  };
  const _renderEmptyMessage = () => {
    return (
      <div className="de--def__folder-list--empty">No folders to display</div>
    );
  };

  return (
    <div className="de--def__folder-card" style={{ height: maxHeight }}>
      <div className="de--def__folder-header">
        <h4>{title}</h4>
      </div>
      <div className="de--def__folder-body">
        <div className="de--def__folder-list">
          {folders.length > 0 ? _renderFolderList() : _renderEmptyMessage()}
        </div>
      </div>
    </div>
  );
};

DefinationFolderView.propTypes = {
  title: string.isRequired,
  folders: instanceOf(Array),
  setActiveStudyTarget: func,
  maxHeight: number,
};

export default DefinationFolderView;
